module.exports = __webpack_public_path__ + "img/i-matrix.be108242.png";